export { default as NTreeSelect, treeSelectProps } from './src/TreeSelect';
